<script setup lang="ts">
/**
 * The echo of the pharmacist in the fil: the trace an action leaves.
 *
 * A scene renders it where the pharmacist acted — a quick reply clicked, a
 * note sent — so the fil, frozen included, still reads as the conversation
 * it was.
 */
defineProps<{text: string}>();
</script>

<template>
  <div
    class="self-end max-w-[70%] bg-primary text-white px-4 py-2.5 text-sm leading-normal
           rounded-l-2xl rounded-tr-2xl rounded-br"
  >
    {{ text }}
  </div>
</template>
